// La prima release copre solo l'anno d'imposta 2026: niente `new Date().getFullYear()`,
// altrimenti la UI e i test end-to-end cambierebbero comportamento al cambio d'anno
// senza che nulla sia cambiato nel codice. Quando il Task 7 espone l'anno dalla
// dichiarazione corrente dell'impianto, questa costante smette di essere usata li'.
export const ANNO_IMPOSTA = 2026
